"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
exports.ThemeEngine = ThemeEngine;
exports.Themes = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash.kebabcase"));
var _theme = _interopRequireDefault(require("./theme.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Themes = exports.Themes = /*#__PURE__*/function (Themes) {
  Themes["Light"] = "light";
  Themes["Dark"] = "dark";
  return Themes;
}({});
var Component = exports.Component = /*#__PURE__*/_react.default.memo(_ref => {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? Themes.Dark : _ref$theme,
    _ref$element = _ref.element,
    element = _ref$element === void 0 ? document.documentElement : _ref$element,
    _ref$themes = _ref.themes,
    themes = _ref$themes === void 0 ? _theme.default : _ref$themes;
  writeThemePropertiesToElement(themes[theme], element);
  return null;
});
function writeThemePropertiesToElement(theme, element) {
  Object.keys(theme).forEach(cssProperty => {
    element.style.setProperty("--".concat((0, _lodash.default)(cssProperty)), theme[cssProperty]);
  });
}
function ThemeEngine(props) {
  return /*#__PURE__*/_react.default.createElement(Component, {
    theme: props.theme
  });
}
//# sourceMappingURL=ThemeEngine.js.map